<template>
	<div id="searchableSelectBox">
		<input
			:id="id"
			type="text"
			autocomplete="off"
			:placeholder="placeholder"
			@focus="focus = true"
			@blur="focus = false"
			@keyup="keyup"
			:class="'searchField' + (additionalClass ? ' ' + additionalClass : '')"
			:disabled="disabled"
		>
		<div class="expandable" :id="id + '-expandable'">
			<ul :id="id + '-items'">
				<li
					v-for="(v, k) in model"
					:key="v instanceof Object ? v.key: k"
					@mouseover="mouseover"
					@click="click"
					@mousemove="mousemove"
					:style="v instanceof Object ? 'line-height: 19px;' : 'line-height: 28px;'"
				>
					<template v-if="v instanceof Object">
						<span class="crossLine">
							{{ spacing ? (withTree ? "│" : "ㅤ").repeat(v.space > 0 ? v.space - 1 : 0) + (withTree ? (v.space > 0 ? model.length - 1 > k ? v.space <= model[k + 1].space ? "├" : "└" : v.space > 0 ? "└" : "" : "") : v.space > 0 ? "ㅤ" : "") : "" }}
						</span>
						{{ v.value }}
					</template>

					<template v-else>{{ v }}</template>
				</li>
			</ul>
		</div>
	</div>

</template>

<script>
export default {
	name: "SearchableSelectBox",
	props: [
		'id',
		'placeholder',
		'containerHeight',
		'themeColor',
		'fontColor',
		'model',
		'valueIfNotFound',
		'searchTextLengthConditions4displayingLists',
		'disabled',
		'spacing',
		'withTree',
		'additionalClass'
	],
	data() {
		let focus = document.querySelector('#' + this.id) === document.activeElement

		return {
			searchText: "",
			focus: focus,
			isPreventMouseoverAction: false,
			selectedKey: this.valueIfNotFound,
			crossLineRegEx: /[─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊]/g
		}
	},
	created() {
		this.themeColor = !this.themeColor ? "#FFFFFF" : this.themeColor
		this.fontColor = !this.fontColor ? "#000000" : this.fontColor
	},
	mounted() {
		this.setupUI()
	},
	methods: {
		setupUI() {
			Array.prototype.slice.call(document.querySelector('#' + this.id + '-items').children).filter(e => {
				e.style.backgroundColor = this.customStyle["--theme-color"]
				e.style.color = this.customStyle["--font-color"]

				if (this.searchText.length < this.searchTextLengthConditions4displayingLists) {
					e.style.display = 'none'
				}
			})
		},

		keyup(e) {
			e.preventDefault()

			const $ = window.$
			const searchField = document.querySelector('#' + this.id)

			$(document).ready(function () {
				$(window).keydown(function (event) {
					if (event.keyCode === 13 && searchField === document.activeElement) {
						event.preventDefault()
						return false
					}
				})
			})

			this.isPreventMouseoverAction = true

			let items
				, activeItem
				, activeItemIndex
				, containerBottomY
				, containerTopY
				, contentBottomY
				, contentTopY
				, contentHeight
			const container = document.querySelector('#' + this.id + '-expandable')

			const setupValue = () => {
				items = Array.prototype.slice.call(document.querySelector('#' + this.id + '-items').children).filter(e => e.style.display !== 'none')
				activeItem = document.querySelector("#" + this.id + "-items>li.active")
				activeItemIndex = items.indexOf(activeItem)

				containerBottomY = container.clientHeight + container.scrollTop
				containerTopY = container.scrollTop
				contentBottomY = items.length > 0 ? items[0].offsetHeight * (activeItemIndex + 1) : 0
				contentTopY = items.length > 0 ? items[0].offsetHeight * (activeItemIndex) : 0
				contentHeight = items.length > 0 ? items[0].offsetHeight : 0
			}

			setupValue()

			const setupDefaultItem = () => {
				if (activeItemIndex === -1) {
					if (items.length > 0) {
						items[0].classList.add("active")
					}
				}
			}
			setupDefaultItem()

			switch (e.code) {
				case "ArrowUp":
					if (activeItemIndex > 0) {
						items[activeItemIndex - 1].classList.add("active")
						activeItem.classList.remove("active")
					}
					break
				case "ArrowDown":
					if (activeItemIndex < items.length - 1) {
						items[activeItemIndex + 1].classList.add("active")
						if (activeItem) activeItem.classList.remove("active")
					}
					break
				case "Enter":
					if (items.length > 0) {
						if (activeItem) {
							this.searchText = activeItem.innerText
							if (this.spacing) {
								this.searchText = this.searchText.replaceAll("ㅤ", "")
								if (this.withTree) {
									this.searchText = this.searchText.replaceAll(this.crossLineRegEx, "").trim()
								}
							}

							$("#" + this.id).val(this.searchText)

							searchField.blur()
						}
					} else {
						searchField.blur()
					}
					break
				default:
					break
			}
			if (activeItem) {
				activeItem.style.backgroundColor = this.customStyle["--theme-color"]
				activeItem.style.color = this.customStyle["--font-color"]
			}
			setupValue()
			if (activeItem) {
				activeItem.style.backgroundColor = this.customStyle["--active-theme-color"]
				activeItem.style.color = this.customStyle["--active-font-color"]
			}

			if (contentTopY < containerTopY) {
				container.scrollTo(0, contentTopY + -(contentHeight / 2))
			} else if (containerBottomY < contentBottomY) {
				container.scrollBy({left: 0, top: contentBottomY - containerBottomY + (contentHeight / 2), behavior: 'smooth'})
			}

			this.searchText = window.$('#' + this.id).val()
		},

		mouseover(e) {
			e.preventDefault()

			const activeItem = document.querySelector("#" + this.id + "-items>li.active")

			if (!this.isPreventMouseoverAction) {
				if (activeItem) {
					activeItem.classList.remove("active")
					activeItem.style.backgroundColor = this.customStyle["--theme-color"]
					activeItem.style.color = this.customStyle["--font-color"]
				}
				let target = e.target instanceof HTMLSpanElement ? e.path[1] : e.target
				target.classList.add("active")
				target.style.backgroundColor = this.customStyle["--active-theme-color"]
				target.style.color = this.customStyle["--active-font-color"]
			}
		},

		click(e) {
			e.preventDefault()
			if (e.target instanceof HTMLSpanElement) {
				this.searchText = e.path[1].innerText
			} else {
				this.searchText = e.target.innerText
			}
			if (this.spacing) {
				this.searchText = this.searchText.replaceAll("ㅤ", "")
				if (this.withTree) {
					this.searchText = this.searchText.replaceAll(this.crossLineRegEx, "").trim()
				}
			}
		},

		mousemove(e) {
			e.preventDefault()
			this.isPreventMouseoverAction = false
		},

		getKey(key) {
			this.$emit("getKey", key ? key : this.valueIfNotFound);
		},

		key() {
			return this.selectedKey ? this.selectedKey : this.valueIfNotFound
		},

		updateModel(model) {
			this.model = model
		},

		getDarkerThemeColor(col, amt) {
			let rgb = parseInt(col, 16)

			let br = (rgb >> 16) & 0xFF
			let bb = (rgb >> 8) & 0xFF
			let bg = (rgb >> 0) & 0xFF

			let ar = br + Math.abs(((amt < 0 ? 0 : 255) - br) / 255) * amt
			let ab = bb + Math.abs(((amt < 0 ? 0 : 255) - bb) / 255) * amt
			let ag = bg + Math.abs(((amt < 0 ? 0 : 255) - bg) / 255) * amt

			let newColor = ag | (ab << 8) | (ar << 16)

			return newColor.toString(16)
		},

		ruma(col) {
			let rgb = parseInt(col, 16)

			let r = (rgb >> 16) & 0xFF
			let g = (rgb >> 8) & 0xFF
			let b = (rgb >> 0) & 0xFF

			return 0.2126 * r + 0.7152 * g + 0.0722 * b
		},

		reverse(col) {
			let rgb = parseInt(col, 16)

			let r = Math.abs(255 - ((rgb >> 16) & 0xFF))
			let g = Math.abs(255 - ((rgb >> 8) & 0xFF))
			let b = Math.abs(255 - ((rgb >> 0) & 0xFF))

			let newColor = g | (b << 8) | (r << 16)

			return newColor.toString(16)
		},

		hasNotLastKOR(word) {
			if (typeof word !== 'string') return false
			if (/[ㄱ-ㅎ|ㅏ-ㅣ]/.test(word)) return true

			let last = word[word.length - 1]
			if (!last) return false
			let uni = last.charCodeAt(0)

			if (uni < 44032 || uni > 55203) return false

			return (uni - 44032) % 28 === 0
		}
	},
	computed: {
		customStyle() {
			let numCol = this.themeColor.replaceAll("#", "")
			let numFontCol = this.fontColor.replaceAll("#", "")

			let activeThemeColorPercent = ((255 - this.ruma(numCol)) / 255) * 90 + 10
			let activeThemeColor = this.getDarkerThemeColor(numCol, this.ruma(numCol) > 80 ? -1 * activeThemeColorPercent : activeThemeColorPercent)

			let fontColor = this.ruma(numCol) > 80 ? `#${numFontCol}` : `#${this.reverse(numFontCol)}`
			let activeFontColor = this.ruma(activeThemeColor) > 80 ? `#${numFontCol}` : `#${this.reverse(numFontCol)}`

			return {
				'--theme-color': this.themeColor,
				'--active-theme-color': `#${activeThemeColor}`,
				'--font-color': `${fontColor}`,
				'--active-font-color': `${activeFontColor}`
			}
		}
	},
	watch: {
		'searchText': function (v, p) {
			let activeItem = document.querySelector("#" + this.id + "-items>li.active")

			if (v !== p && activeItem) {
				activeItem.classList.remove('active')
				activeItem.style.backgroundColor = this.customStyle["--theme-color"]
				activeItem.style.color = this.customStyle["--font-color"]
			}

			Array.prototype.slice.call(document.querySelector("#" + this.id + "-items").children).forEach(e => {
				e.style.display = 'block'
				if (e.innerText.indexOf(v) === -1) {
					e.style.display = 'none'
				}

				if (v.length < this.searchTextLengthConditions4displayingLists) {
					e.style.display = 'none'
				}
			})

			if (this.model instanceof Array) {
				const tmpObj = {}
				this.model.forEach(e => {
					tmpObj[e.key] = e.value
				})
				this.selectedKey = Object.keys(tmpObj).find(key => tmpObj[key] === v)
			} else if (this.model instanceof Object) {
				this.selectedKey = Object.keys(this.model).find(key => this.model[key] === v)
			}

			$("#" + this.id).val(this.searchText)

			this.getKey(this.selectedKey)
		},

		'focus': function () {
			document.querySelector('#' + this.id + '-expandable').classList.toggle('expand')
			this.getKey(this.selectedKey)
		},

		'model': function () {
			this.$nextTick(() => {
				this.setupUI()
			})
		}
	}
}
</script>

<style>
.searchField,
.expandable {
	width: 100%;
}

.expandable {
	max-height: 0;
	overflow-y: scroll;
	overflow-x: hidden;
	transition: all .6s ease;
	-ms-overflow-style: none;
}

.expandable.expand {
	max-height: 250px;
	padding-bottom: 0;
}

.expandable > ul {
	background-color: var(--theme-color);
}

.expandable > ul > li {
	transition: all .2s ease;
	padding: 0 15px;
	font-size: 14px;
	height: 28px;
}

.crossLine {
	background-color: rgba( 255, 255, 255, 0 );
	opacity: 0.1;
	height: 28px;
	font-size: 28px;
}

.expandable > ul > li.active {
}

</style>